import { TuiRoot } from '@taiga-ui/core';
import {Component, inject, signal} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {Subject, takeUntil} from 'rxjs';
import {EventsService} from './shared/services/events.service';
import {AuthService} from './shared/services/auth.service';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TuiRoot],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  standalone:true
})
export class App {
  eventsService = inject(EventsService);
  toastrService = inject(ToastrService);
  router = inject(Router)
  authService = inject(AuthService);

  title = 'blog-admin';
  destroy$ = new Subject();

  ngOnInit(): void {
  }

  constructor() {
    this.InitToastr();
    this.AuthCheck();
  }

  AuthCheck() {
    if (this.authService.HasTokens()) {
      this.authService.GetMe().subscribe();
    } else {
      this.authService.CLearSession();
      this.router.navigate(['/auth']);
    }
  }

  InitToastr() {
    this.eventsService.IsErrorChange$
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe((res) => {
        if (res && this.eventsService.Error.status) {
          this.toastrService.error(this.eventsService.Error.text, "Ошибка!", {
            positionClass: "toast-bottom-center",
            titleClass: 'title-toast'

          });
        } else {
          this.toastrService.clear();
        }
      })

    this.eventsService.IsSuccessChange$
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe((res) => {
        if (res && this.eventsService.Success.status) {
          this.toastrService.success(
            this.eventsService.Success.text,
            "Операция выполнена успешно",
            {
              positionClass: "toast-bottom-center",
              titleClass: 'title-toast'
            }
          );
        } else {
          this.toastrService.clear();
        }
      })
  }
}
